(() => {
  angular.module('pims').filter('stringify', () => {
    'ngInject';

    return (input, delimiter) => {
      switch (delimiter) {
        case 'comma':
          delimiter = ', ';
          break;

        case 'space':
        default:
          delimiter = ' ';
          break;
      }

      let string = '';

      for (const key in input) {
        if (input.hasOwnProperty(key)) {
          string += `${input[key] + delimiter}`;
        }
      }

      return string.substring(0, string.lastIndexOf(delimiter));
    };
  });
})();